import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Home from './components/home/HomeComponent'
import Chapters from './components/chapters/ChaptersComponent';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import HeaderComponent from './components/header/HeaderComponent';
import BannerComponent from './components/bannerComponent/BannerComponent';
import FooterComponent from './components/footerComponent/FooterComponent';

function App() {
  return (
    <Router>
      <HeaderComponent />
      <BannerComponent />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/chapters" element={<Chapters />} />
        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
      <FooterComponent />
    </Router>
  );
}

export default App;
